export const OUTLET = "/outlet";
export const ADMIN_LOGIN = "/admins/login";
export const SETTINGS = "/settings";
export const NOTIFICATION = "/notification";
export const MERCHANTS = "/merchants";
export const ADMIN_DASHBOARD = "/admins/dashboard";
export const TRANSACTION_CUSTOMER = "/transaction/customer";
export const TRANSACTION_MERCHANT = "/transaction/merchant";
export const TRANSACTION_TOPUPS = "/transaction/top-ups";
export const TRANSACTION_DOWNLOAD_REPORT = "/transaction/download-report";
export const TOP_UP_TRANSACTION_DOWNLOAD_REPORT =
  "/transaction/download-top-up-report";
export const CARDS = "/cards";
export const GENERATE_PHYSICAL_CARDS = "/cards/generate-cards";
export const TOP_UP_COUNTS = "/transaction/top-up-counts/current-day";
export const REFUND_DISPUTE_LIST = "/refund/admindisputelist";
export const REFUND_DISPUTE_PROCESS = "/refund/process";
export const DOWNLOAD_DISPUTE_REFUND =
  "/refund/download-refund-transaction-report";
export const REFUND_ADMIN_REQUEST = "/refund/admin_request_to_dispute";
export const EVENTS = "/events";
export const MEMBERSHIP = "/membership";
export const PRODUCT = "/product";
export const ADMIN = "/admin";
export const BERTHTARIFF = "/berthtariff";
export const YACHT = "/yacht";
export const CASHCHEQUEPAYMENT = "/cash-cheque-payment";
export const APPROVAL = "/approval";
export const PARKING_LAYOUT = "/parking/layout";
export const ADDITIONAL_SERVICE = "/yachtAddService";
export const COMPLETE = "/complete";
export const PROMO = "/promotion";
export const CHECKOUT = "/checkout";
export const AQUA_CALENDAR = "/aquacalender";
export const USER = "/users";
export const AGENT_LIST = "/getAgentList";
export const ALAMAHA = '/almaha'
export const ADMIN_LIST = '/adminList'
export const SOURCE = '/source'
export const ADMIN_REPORT = '/admin-download-report'
export const BLOCK_SLOT = '/blockSlot'
export const ENABLE_SLOT = '/enableSlot'
export const PRIVILEGE = '/privilege'
export const GET_ALL_PRIVILEGE = '/getAllPrivilege'
export const LWW_TICKETS = '/getBookings'
export const LWW_QRCODE = '/adminTicket'


